import { DocumentType } from '@rematter/frontend-lib-api-client';

import { FileMetadata } from '~/shared/types/file';

export enum enumComplianceOptions {
  documented = 'documented',
  pending = 'pending',
  none = 'none',
}

export enum enumCatalyticConverterDetails {
  serialNumber = 'serialNumber',
  oemCode = 'oemCode',
  compliance = 'compliance',
}

export enum enumVehicleDetails {
  vin = 'vin',
  make = 'make',
  model = 'model',
  year = 'year',
}

export type WeightUnitMode = 'scale' | 'manual';

export type TicketDirection = 'inbound' | 'outbound';

export type ScaleTicketTab =
  | 'materials'
  | 'deductions'
  | 'notes'
  | 'photos'
  | 'files'
  | 'supplierInfo'
  | 'customerInfo'
  | 'details'
  | 'documents'
  | 'history'
  | 'compliance';

export type LayoutViewMode = 'grid' | 'camera';

export type TicketListFilter = {
  statuses: string[];
  searchTerm: string;
  accountIds: string[];
};

export type TicketDocumentSelection = Record<DocumentType, boolean>;

export type TicketPhotoWithOptimistic = {
  id: string;
  url: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  status: string;
  metadata?: FileMetadata | null;
  createdAt: unknown;
  updatedAt: unknown;
  _optimistic?: {
    type: 'update' | 'delete';
    status: 'pending' | 'error';
    error?: string;
  };
};

export type PrintableDocument = {
  label: string;
  documentType: DocumentType;
  loadId: string;
  purchaseOrderId?: string;
  salesOrderId?: string;
  invoiceId?: string;
  isDisabled?: boolean;
  toastMessage: string;
};
